import { css } from '@emotion/react';
import { Typography, useTheme } from '@mui/material';
import Grid from '@mui/material/Grid';
import { useEffect, useState } from 'react';
import packageJSON from '../../package.json';
import { getClientConfig } from '../Config/ClientConfig';
import Colors from '../theme/colors';

const useStyles = () => {
  const theme = useTheme();
  return {
    footerText: css({
      zIndex: 1000,
      padding: theme.spacing(1.25, 0, 0.75, 2),
      margin: '0 auto 0 0',
      fontSize: 12,
      width: '100%',
      minHeight: 49,
      backgroundColor: Colors.mildGray,
      [`& .MuiGrid-item`]: {
        paddingTop: '12px ',
      },
    }),
    packageVersion: css({
      flexGrow: 1,
      display: 'flex',
      justifyContent: 'end',
      alignItems: 'flex-end',
    }),
  };
};

export default function Footer() {
  const [appVersion, setAppVersion] = useState('');
  const [systemVersion, setSystemVersion] = useState('');
  const [packageVersion, setPackageVersion] = useState('');

  useEffect(() => {
    (async () => {
      const { appVersion, showPackageVersion, systemVersion } = await getClientConfig();
      setAppVersion(appVersion);
      setSystemVersion(systemVersion);
      if (showPackageVersion) {
        setPackageVersion(packageJSON.version);
      }
    })();
  }, []);

  const styles = useStyles();

  return (
    <Grid
      css={styles.footerText}
      style={packageVersion ? { minHeight: 90 } : undefined}
      container
      spacing={6}
      id='footer-container'
    >
      <Grid item>
        Karius Portal v{appVersion}/{systemVersion}
      </Grid>
      <Grid item>975 Island Drive, Suite 101 Redwood City, CA 94065</Grid>
      <Grid item>CLIA #05D2121236</Grid>
      <Grid item>CAP #9497749</Grid>
      {packageVersion && (
        <Grid css={styles.packageVersion} item>
          <Typography variant='caption' sx={{ pr: 2 }}>
            Package Version: {packageVersion}
          </Typography>
        </Grid>
      )}
    </Grid>
  );
}
